"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-3b060def"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "roles-auto-role"
};
const _hoisted_2 = { class: "auto-role-wrapper" };
const _hoisted_3 = {
    for: "all-roles",
    class: "oplus-form-checkbox"
};
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("strong", null, "全部", -1 /* HOISTED */));
const _hoisted_5 = ["onClick", "data-role"];
const _hoisted_6 = ["value"];
const _hoisted_7 = { key: 1 };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "empty centered" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("p", { class: "empty-title h5" }, "業務がありません"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("p", { class: "empty-subtitle" }, "業務管理ページから業務を作成してください。")
], -1 /* HOISTED */));
const _hoisted_9 = [
    _hoisted_8
];
const vue_3 = require("vue");
const OrMainRoleIcon_vue_1 = __importDefault(require("../../../../vue/icons/OrMainRoleIcon.vue"));
const provider_1 = require("../../../../provider/provider");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIRoles',
    setup(__props) {
        const viewModel = (0, vue_3.inject)(provider_1.autoAIViewModelInjectKey);
        const presenter = (0, vue_3.inject)(provider_1.autoAIPresenterInjectKey);
        const showPopup = (0, vue_3.ref)(null);
        const selectAll = (0, vue_3.computed)({
            get: () => checkedRoles.value.length > 0 && checkedRoles.value.length === viewModel?.value.roles.length,
            set: (checked) => presenter?.toggleAllCheckedRoles(checked),
        });
        const checkedRoles = (0, vue_3.computed)({
            get: () => viewModel?.value.checkedRoles ?? [],
            set: (ids) => presenter?.setCheckedRoles(ids),
        });
        const roles = (0, vue_3.computed)(() => {
            return viewModel?.value.roles || [];
        });
        function setRoleColor(role) {
            if (!role?.color) {
                return;
            }
            return {
                backgroundColor: `#${role.color}`,
                color: '#fff',
            };
        }
        function toggleAllCheckboxes() {
            presenter?.toggleAllCheckedRoles(selectAll.value);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createCommentVNode)(" Roles "),
                (roles.value.length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("label", _hoisted_3, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectAll).value = $event)),
                                    type: "checkbox",
                                    name: "all",
                                    id: "all-roles",
                                    onChange: toggleAllCheckboxes
                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, selectAll.value]
                                ]),
                                _hoisted_4
                            ]),
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(roles.value, (role, index) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: role.getOriginalId()
                                }, [
                                    (0, vue_2.createElementVNode)("label", {
                                        onClick: ($event) => (showPopup.value = index),
                                        onMouseleave: _cache[2] || (_cache[2] = ($event) => (showPopup.value = null)),
                                        class: "oplus-form-checkbox",
                                        "data-role": role.getOriginalId()
                                    }, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            value: role.getOriginalId(),
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((checkedRoles).value = $event)),
                                            class: "auto-role-checkbox text-popup",
                                            type: "checkbox"
                                        }, null, 8 /* PROPS */, _hoisted_6), [
                                            [vue_2.vModelCheckbox, checkedRoles.value]
                                        ]),
                                        (0, vue_2.createElementVNode)("span", {
                                            class: "role-name auto-role-name",
                                            style: (0, vue_2.normalizeStyle)(setRoleColor(role))
                                        }, [
                                            (role.isMainRole())
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(OrMainRoleIcon_vue_1.default, { key: 0 }))
                                                : (0, vue_2.createCommentVNode)("v-if", true),
                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(role.getName()), 1 /* TEXT */)
                                        ], 4 /* STYLE */),
                                        (0, vue_2.createVNode)(vue_2.Transition, {
                                            name: "fade",
                                            persisted: ""
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("span", { class: "auto-role-text-popup" }, (0, vue_2.toDisplayString)(role.getName()), 513 /* TEXT, NEED_PATCH */), [
                                                    [vue_2.vShow, showPopup.value === index]
                                                ])
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_5)
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, _hoisted_9))
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
        };
    }
});
